module.exports = __webpack_public_path__ + "img/CertifiedNet.8ab3498f.png";